{
  "login": {
    "genericError": "Произошла ошибка при входе. Пожалуйста, попробуйте снова."
  },
  "acceptTerms": {
    "pleaseAccept": "Примите Условия использования для продолжения",
    "accepted": "Условия использования приняты",
    "failedGeneric": "Не удалось принять условия. Пожалуйста, попробуйте снова."
  },
  "discord": {
    "linkSuccess": "Аккаунт Discord привязан! Пожалуйста, проверьте ваши ЛС ниже.",
    "linkFailed": "Не удалось привязать аккаунт Discord: {{message}}",
    "verificationSent": "Код подтверждения отправлен в ваши ЛС Discord!",
    "dmVerified": "ЛС Discord успешно подтверждены! Уведомления теперь доступны.",
    "settingToggled": "{{label}} {{state}}",
    "unlinked": "Аккаунт Discord успешно отвязан!",
    "userIdNotFound": "ID пользователя не найден. Пожалуйста, войдите снова.",
    "clientIdNotConfigured": "ID клиента Discord не настроен. Проверьте переменные окружения.",
    "redirectUriNotConfigured": "URL перенаправления настроен неверно. Проверьте переменные окружения.",
    "allowPopups": "Пожалуйста, разрешите всплывающие окна на этом сайте для привязки аккаунта Discord",
    "linkFirst": "Пожалуйста, сначала привяжите аккаунт Discord",
    "sendCodeFailed": "Не удалось отправить код верификации. Убедитесь, что бот может отправлять вам личные сообщения.",
    "sendCodeFailedGeneric": "Не удалось отправить код верификации",
    "enterCode": "Пожалуйста, введите код верификации",
    "verifyCodeFailed": "Не удалось проверить код. Пожалуйста, попробуйте снова.",
    "verifyFirst": "Пожалуйста, сначала подтвердите ваши личные сообщения Discord",
    "updateSettingFailed": "Не удалось обновить настройки уведомлений",
    "unlinkFailed": "Не удалось отвязать аккаунт Discord",
    "categoryUpdated": "Категория обновлена",
    "categoryUpdateFailed": "Не удалось обновить категорию",
    "categoryDeleted": "Категория удалена",
    "categoryDeleteFailed": "Не удалось удалить категорию",
    "defaultCategoryUpdated": "Категория по умолчанию обновлена",
    "setDefaultFailed": "Не удалось задать категорию по умолчанию",
    "categoryCreated": "Категория создана",
    "categoryCreateFailed": "Не удалось создать категорию"
  },
  "subscription": {
    "failedLoadPricing": "Не удалось загрузить информацию о ценах",
    "failedCheckout": "Не удалось инициировать оплату",
    "failedChangeSubscription": "Не удалось изменить подписку",
    "failedOpenBillingPortal": "Не удалось открыть портал выставления счетов",
    "cancelSuccess": "Ваша подписка успешно отменена",
    "cancelFailed": "Не удалось отменить подписку",
    "resumeSuccess": "Ваша подписка успешно возобновлена",
    "resumeFailed": "Не удалось возобновить подписку",
    "updateSuccess": "Ваша подписка обновлена!",
    "newSubscriptionSuccess": "Добро пожаловать! Ваша подписка активна."
  },
  "trial": {
    "activated": "Пробный период активирован! Наслаждайтесь 7 днями FlippingPal.",
    "activationFailed": "Не удалось активировать пробный период"
  },
  "account": {
    "emailBothFieldsRequired": "Пожалуйста, заполните оба поля",
    "emailInvalid": "Пожалуйста, введите действительный адрес электронной почты",
    "emailUpdated": "Email обновлён! Проверьте новый email для подтверждения. Выход из системы...",
    "emailFailed": "Не удалось изменить email",
    "passwordAllFieldsRequired": "Пожалуйста, заполните все поля пароля",
    "passwordTooShort": "Новый пароль должен содержать не менее 4 символов",
    "passwordsDoNotMatch": "Новые пароли не совпадают",
    "passwordChanged": "Пароль успешно изменён!",
    "passwordFailed": "Не удалось изменить пароль",
    "closeAccountPasswordRequired": "Пожалуйста, введите ваш пароль",
    "closeAccountConfirmRequired": "Пожалуйста, введите \"ЗАКРЫТЬ МОЙ АККАУНТ\" для подтверждения",
    "accountClosed": "Аккаунт закрыт. Выход из системы...",
    "closeAccountFailed": "Не удалось закрыть аккаунт"
  },
  "snipe": {
    "ilvlEnterAtLeastOne": "Пожалуйста, введите хотя бы один из ilvl мин или макс",
    "ilvlValidMin": "Пожалуйста, введите допустимый минимальный ilvl",
    "ilvlValidMax": "Пожалуйста, введите допустимый максимальный ilvl",
    "ilvlMinExceedsMax": "Минимальный ilvl не может превышать {{max}}",
    "ilvlMaxExceedsMax": "Максимальный ilvl не может превышать {{max}}",
    "ilvlMinGreaterThanMax": "Минимальный ilvl не может быть больше максимального ilvl",
    "ilvlValidPrice": "Пожалуйста, введите допустимую цену (напр. 100g, 50g 30s, или 100)",
    "reqLvlMinRange": "Минимальный требуемый уровень должен быть между {{min}} и {{max}}",
    "reqLvlMaxRange": "Максимальный требуемый уровень должен быть между {{min}} и {{max}}",
    "reqLvlMinGreaterThanMax": "Минимальный требуемый уровень не может быть больше максимального требуемого уровня",
    "ilvlAdded": "Снайп ilvl добавлен",
    "ilvlUpdated": "Снайп ilvl обновлён",
    "ilvlSaveFailed": "Не удалось сохранить снайп ilvl",
    "ilvlRemoved": "Снайп ilvl удалён",
    "ilvlRemoveFailed": "Не удалось удалить снайп ilvl",
    "selectItem": "Пожалуйста, выберите предмет",
    "validPetId": "Пожалуйста, введите допустимый ID питомца или найдите питомца",
    "invalidPrice": "Пожалуйста, введите допустимую цену (напр. 100g, 50g 30s, или 100)",
    "itemAdded": "Снайп {{label}} добавлен",
    "itemUpdated": "Снайп {{label}} обновлён",
    "itemAddFailed": "Не удалось добавить снайп {{type}}",
    "itemRemoved": "Снайп {{type}} удалён",
    "itemRemoveFailed": "Не удалось удалить снайп {{type}}",
    "editingWoWToken": "Редактирование оповещения о снайпе WoW Token",
    "editingSnipeAlert": "Редактирование оповещения о снайпе для {{name}}",
    "itemNotFound": "{{label}} не найден.",
    "importInvalidArrayFormat": "Неверный формат. Ожидался массив правил снайпа ilvl.",
    "importNoValidEntries": "Допустимые записи не найдены. Элементы массива должны содержать поля \"{{idKey}}\" и \"price\".",
    "importInvalidJsonFormat": "Неверный формат JSON. Ожидалось { {{idKey}}: goldPrice, ... } или массив объектов.",
    "importSuccess": "Импорт: {{added}} добавлено, {{updated}} обновлено, {{skipped}} пропущено",
    "importIlvlSuccess": "Импортировано {{count}} правил снайпа ilvl",
    "importParseFailed": "Не удалось разобрать или импортировать JSON",
    "noItemsToExport": "Нет {{type}} для экспорта",
    "noIlvlItemsToExport": "Нет предметов ilvl для экспорта",
    "exportSuccess": "Экспортировано {{count}} {{type}}",
    "exportIlvlSuccess": "Экспортировано {{count}} предметов ilvl",
    "enabledToggle": "Снайп-оповещения {{state}}",
    "enabledToggleFailed": "Не удалось обновить настройку снайпа",
    "alertStyleUpdated": "Стиль оповещения установлен на {{style}}",
    "alertStyleFailed": "Не удалось обновить стиль оповещения",
    "realmsSaved": "Реалмы снайпа сохранены",
    "realmsSaveFailed": "Не удалось сохранить реалмы снайпа",
    "clearAllConfirm": "Вы уверены, что хотите удалить все снайпы {{label}}?",
    "clearAllSuccess": "Все снайпы {{label}} удалены",
    "clearAllFailed": "Не удалось удалить снайпы {{label}}",
    "cooldownCyclesUpdated": "Задержка оповещений установлена: пропускается {{cycles}} цикл(ов)",
    "cooldownCyclesFailed": "Не удалось обновить задержку оповещений",
    "cooldownCyclesInvalid": "Задержка должна быть от 0 до 24 циклов",
    "undo": "Отменить",
    "undoRestored": "Оповещение снайпа восстановлено",
    "undoFailed": "Не удалось восстановить оповещение снайпа",
    "priceUpdated": "Цена обновлена",
    "priceUpdateFailed": "Не удалось обновить цену"
  },
  "personalConfig": {
    "saveSuccess": "Настройки фильтров по умолчанию успешно сохранены!",
    "saveFailed": "Не удалось сохранить настройки фильтров по умолчанию"
  },
  "auth": {
    "registrationSuccessEmail": "Регистрация прошла успешно! Пожалуйста, проверьте вашу почту для подтверждения.",
    "registrationSuccessLogin": "Регистрация прошла успешно! Пожалуйста, войдите с вашим новым аккаунтом.",
    "passwordResetSuccess": "Пароль успешно сброшен"
  },
  "common": {
    "networkError": "Ошибка сети. Пожалуйста, попробуйте снова."
  },
  "validation": {
    "passwordRequired": "Пароль обязателен",
    "passwordMinLength": "Пароль должен содержать не менее {{count}} символов",
    "passwordUppercase": "Пароль должен содержать хотя бы одну заглавную букву",
    "passwordLowercase": "Пароль должен содержать хотя бы одну строчную букву",
    "passwordNumber": "Пароль должен содержать хотя бы одну цифру",
    "passwordSpecialChar": "Пароль должен содержать хотя бы один специальный символ",
    "confirmPasswordRequired": "Пожалуйста, подтвердите пароль",
    "passwordsDoNotMatch": "Пароли не совпадают",
    "emailRequired": "Email обязателен",
    "emailInvalid": "Пожалуйста, введите действительный адрес электронной почты"
  },
  "filterPreset": {
    "fetchFailed": "Не удалось загрузить предустановки фильтров",
    "createFailed": "Не удалось создать предустановку фильтра",
    "updateFailed": "Не удалось обновить предустановку фильтра",
    "deleteFailed": "Не удалось удалить предустановку фильтра",
    "invalidImportNotObject": "Недействительная строка импорта: не является допустимым объектом предустановки",
    "invalidImportMissingVersion": "Недействительная строка импорта: отсутствует информация о версии",
    "invalidImportMissingPreset": "Недействительная строка импорта: отсутствуют данные предустановки",
    "invalidPresetMissingName": "Недействительная предустановка: отсутствует или недопустимое имя",
    "invalidPresetMissingFilters": "Недействительная предустановка \"{{name}}\": отсутствуют или недопустимые фильтры"
  }
}
